import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAddComment({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M8 2a6 6 0 0 0-6 6v4.5A1.5 1.5 0 0 0 3.5 14H8A6 6 0 0 0 8 2zm0 1a5 5 0 0 0-5 5v4.5a.5.5 0 0 0 .5.5H8A5 5 0 0 0 8 3zm3 4a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5A.5.5 0 0 0 11 7zM8.5 9a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3z"/>
        </svg>
    );
}

export default IconAddComment;
